import '@fabric-ds/icons/elements/search-24';
import React from 'react';

type SearchboxButtonProps = {
    className?: string;
};

export function SearchboxButton(props: SearchboxButtonProps) {
    const { className = '' } = props;

    return (
        <button
            className={`${className} absolute top-0 bottom-0 hover:text-aqua-400 flex justify-center items-center focus-ring right-0  w-40`}
            type="submit"
            aria-label="Søk"
        >
            {/* @ts-expect-error Property 'f-icon-search24' does not exist on type 'JSX.IntrinsicElements'.ts(2339) */}
            <f-icon-search24 class="flex" />
        </button>
    );
}
